export function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getRandomId(prefix = "") {
  return `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
}
